export default "__VITE_ASSET__BUXXmzmT__"